import { Link } from "react-router-dom";

interface SectionHeaderProps {
    title: string;
    viewAllHref?: string;
}

export const SectionHeader = ({ title, viewAllHref }: SectionHeaderProps) => {
    return (
        <div className="flex items-center justify-between mb-3 px-1">
            <h2 className="text-base md:text-lg font-semibold text-neutral">
                {title}
            </h2>
            {viewAllHref && (
                <Link
                    to={viewAllHref}
                    className="text-sm text-primary hover:underline"
                >
                    View all →
                </Link>
            )}
        </div>
    );
};
